module.exports = __webpack_public_path__ + "static/media/signature.84be641f.png";